import Request from './request';
export default class BackupService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new BackupService();
	}
	
	getVersions(backupSearch) {
		return Request.instance().post('/console/v1/backup/minimal/list', backupSearch)
			.then(response => response.data);
	}

	getVersion(backupSearch) {
		return Request.instance().post('/console/v1/backup/minimal/list', backupSearch)
			.then(response => response.data);
	}

	getCurrentAndChosenVersions(backupSearch) {
		return Request.instance().post('/console/v1/bulk/backup/find/two', backupSearch)
		.then(response => response.data);
	}

}